export const setDocTitle = function (title) {
    if (!title) {
        return;
    }
    document.title = title;
}
export const debounce =function (fn, ms) {
    let timeoutId;
    return function () {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            fn.apply(this, arguments)
        }, ms)
    }
};



// WEBPACK FOOTER //
// ./src/utils/tools.js